import { routes as app } from '../app'
import auth from '../domain/auth/services/auth'
import PrimeiroAcessoDefineSenha from '../app/website/usuarios/components/PrimeiroAcessoDefineSenha'

const root = [
  {path: '/', redirect: '/dashboard'},
  {
    path: '/definir-senha',
    name: 'definir.senha.primeiro.acesso',
    component: PrimeiroAcessoDefineSenha},
  {
    name: 'logout',
    path: '/logout',
    beforeEnter (to, from, next) {
      auth.logout(() => {
        next('/auth')
      })
    }
  }
]

export default [...root, ...app]



// WEBPACK FOOTER //
// ./src/router/routes.js